import { FC } from "react";
import { NotifIconProps } from "./types";
import { Column } from "../../../components/containers";
import { JustifyContent } from "../../../components/containers/types";
import { useThemeStore } from "../../../stores";

const NotifIcon: FC<NotifIconProps> = ({
  Icon,
  hasNotif,
  color,
  height,
  width,
  className = "",
  style = {},
  onClick = () => {},
}) => {
  const theme = useThemeStore((state) => state.theme);
  return (
    <Column
      justifyContent={JustifyContent.Center}
      className={className}
      style={{ position: "relative", ...style }}
      props={{ onClick }}
    >
      {hasNotif ? (
        <div
          style={{
            width: 8,
            height: 8,
            borderRadius: "50%",
            background: theme.primary,
            position: "absolute",
            zIndex: 99,
            top: -4,
            left: -4,
          }}
        ></div>
      ) : (
        <></>
      )}
      <Icon color={color} width={width} height={height} />
    </Column>
  );
};

export default NotifIcon;
